import { useCallback } from 'react';

import { useBrazeContext } from 'state/braze';
import { useLDContext } from 'state/launchdarkly';
import { useMParticleContext } from 'state/mParticle';
import Braze from 'utils/braze';

import { UserDetails } from './types';

export const useThirdPartyAuthentication = () => {
  const { setUserId: brazeSetUserId } = useBrazeContext();
  const { login: launchDarklyLogin, logout: launchDarklyLogout } = useLDContext();
  const { loginCRM, logoutCRM } = useMParticleContext();

  const logUserInToThirdPartyServices = useCallback(
    (currentUser: UserDetails) => {
      launchDarklyLogin(currentUser);

      loginCRM({
        customerid: currentUser.cognitoId,
        rbiCognitoId: currentUser.cognitoId,
        ...currentUser.details,
      });

      brazeSetUserId(
        currentUser.thLegacyCognitoId
          ? `us-east-1:${currentUser.thLegacyCognitoId}`
          : currentUser.cognitoId
      );

      // Update Braze Email for the user
      Braze.setEmail(currentUser.details.email);
    },
    [brazeSetUserId, launchDarklyLogin, loginCRM]
  );

  const logUserOutOfThirdPartyServices = useCallback(() => {
    launchDarklyLogout();
    logoutCRM();
    brazeSetUserId(null);
  }, [brazeSetUserId, launchDarklyLogout, logoutCRM]);

  return { logUserInToThirdPartyServices, logUserOutOfThirdPartyServices };
};
